import { formatSize, getLanguageName } from "@/shared/utils/helpers";
import { languageSharePercent, summaryStatsRecordCount } from "@/features/datasets/utils/datasetSummaryStats";
import { Text } from '@spark';

export const examplesData = [
    {
        key: 1,
        question_id: '1',
        question: "What is the description of the medical code S72.24 in ICD10CM? A. Displaced subtrochanteric fracture of right femur B. Nondisplaced subtrochanteric",
        answer_id: 'B',
        answer: "Nondisplaced subtrochanteric",
        option_1: "Displaced subtrochanteric fracture of right femu",
        option_2: "Nondisplaced subtrochanteric",
        level: "hard",
    },
    {
        key: 2,
        question_id: '2',
        question: "What is the description of the medical code 0PS040 in ICD10PROC? A. Medical and Surgical @ Upper Bones @ Reposition @ Sternum @ Percutaneous Endoscopic @ Internal Fixation Device, Rigid Plate B. Medical and Surgical @ Upper Bones @ Reposition @ Sternum",
        answer_id: 'A',
        answer: "Medical and Surgical @ Upper Bones @ Reposition @ Sternum @ Percutaneous Endoscopic @ Internal Fixation Device, Rigid Plate",
        option_1: "Medical and Surgical @ Upper Bones @ Reposition @ Sternum @ Percutaneous Endoscopic @ Internal Fixation Device, Rigid Plate",
        option_2: "Medical and Surgical @ Upper Bones @ Reposition @ Sternum",
        level: "easy",
    },
    {
        key: 3,
        question_id: '3',
        question: "What is the description of the medical code 658 in ICD9CM? A. Other problems associated with amniotic cavity and membranes B. Open wound of nasal septum, complicated",
        answer_id: 'A',
        answer: "Other problems associated with amniotic cavity and membrane",
        option_1: "Other problems associated with amniotic cavity and membrane",
        option_2: "Open wound of nasal septum, complicated",
        level: "easy",
    },
    {
        key: 4,
        question_id: '4',
        question: "What is the description of the medical code F73 in ICD10CM? A. Profound intellectual disabilities B. Moderate intellectual disabilities",
        answer_id: 'B',
        answer: "Moderate intellectual disabilities",
        option_1: "Profound intellectual disabilities ",
        option_2: "Moderate intellectual disabilities",
        level: "medium",
    },
    {
        key: 5,
        question_id: '5',
        question: "What is the description of the medical code T63.433S in ICD10CM? A. Toxic effect of venom of caterpillars, assault, initial encounter B. Toxic effect of venom of caterpillars",
        answer_id: 'B',
        answer: "Toxic effect of venom of caterpillars",
        option_1: "Toxic effect of venom of caterpillars, assault, initial encounter",
        option_2: "Toxic effect of venom of caterpillars",
        level: "medium",
    },

]

export function getStatisticsLengthData(datasetMetaData) {
    const num_characters = datasetMetaData ? datasetMetaData.num_characters : null;
    const num_words = datasetMetaData ? datasetMetaData.num_words : null;
    if(!num_characters || !num_words) {
        return;
    }

    // Derive the average from sum / record count rather than the stored `avg`,
    // which can be stale (it is only recomputed on some write paths). Prefer
    // the language total when it is larger than `num_records` so an active-only
    // overwrite cannot inflate averages.
    const numRecords = summaryStatsRecordCount(datasetMetaData);
    const wordsAvg = numRecords ? num_words.sum / numRecords : 0;
    const charactersAvg = numRecords ? num_characters.sum / numRecords : 0;

    return [
        {
            key: 1,
            title: <Text variant="base-semibold" as="div">Avg. Text Length</Text>,
            words: wordsAvg.toFixed(2),
            characters: charactersAvg.toFixed(2),
        },
        {
            key: 2,
            title: <Text variant="base-semibold" as="div">Max. Text Length</Text>,
            words: num_words.max,
            characters: num_characters.max,
        },
        {
            key: 4,
            title: <Text variant="base-semibold" as="div">Min. Text Length</Text>,
            words: num_words.min,
            characters: num_characters.min,
        },
    ]
}

// export const statisticsLengthData = [
//     {
//         key: 1,
//         title: <div style={{ fontWeight: 'bold' }}>Avg. Text Length</div>,
//         words: 10,
//         characters: 84,
//     },
//     {
//         key: 2,
//         title: <div style={{ fontWeight: 'bold' }}>Max. Text Length</div>,
//         words: 584,
//         characters: 3658,
//     },
//     {
//         key: 4,
//         title: <div style={{ fontWeight: 'bold' }}>Min. Text Length</div>,
//         words: 1,
//         characters: 3,
//     },
// ]



export function getStatisticsCountData(datasetMetaData) {
    const entries = datasetMetaData ? datasetMetaData.num_records : null;
    if (!entries) {
        return []
    }
    return [
        {
            key: 1,
            title: <Text variant="base-semibold" as="div">Dataset Size</Text>,
            value: formatSize(datasetMetaData.num_characters.sum)
        },
        {
            key: 2,
            title: <Text variant="base-semibold" as="div">Dataset Entries</Text>,
            value: entries
        },
        {
            key: 3,
            title: <Text variant="base-semibold" as="div">Num of Words (white space separator)</Text>,
            value: `Total Num: ${datasetMetaData["num_words"]["sum"]}`
        },
        // {
        //     key: 4,
        //     title: <div style={{ fontWeight: 'bold' }}></div>,
        //     value: 'Unique Num: 2541 (2880 duplicated)'
        // },
        {
            key: 5,
            title: <Text variant="base-semibold" as="div">Num of Characters</Text>,
            value: `Total Num: ${datasetMetaData["num_characters"]["sum"]}`
        },
        // {
        //     key: 6,
        //     title: <div style={{ fontWeight: 'bold' }}></div>,
        //     value: 'Without Punctuation:  819025 (55487)'
        // },
    ]

}

export function getStatisticsLanguageData(_num_rows, language) {
    if (!language) {
        return []
    }
    let data = []
    const languageKeys = Object.keys(language)
    for (let i in languageKeys) {
        const numLanguageRows = language[languageKeys[i]]
        const languageName = getLanguageName(languageKeys[i])
        data = data.concat({
            key: i,
            title: <Text variant="base-semibold" as="div">{languageName}</Text>,
            value: `${languageSharePercent(numLanguageRows, language).toFixed(2)}% of Entries (${language[languageKeys[i]]}) are most likely ${languageName}`
        },)
    }
    return data;
}

export const processedDataInfo = [
    {
        key: 1,
        num_rows_entries: 1269532,
        after_dedup: 28271,
        num_changes_pii: 520,
        num_changes_decontamination: 137,
    },
]